import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

const reg = /\$\{(.+?)\}/;

export default function NavigationLink({
  label,
  isMenuItemActive,
  menu,
  activeMenu,
  link,
  urls,
  isSubMenu,
  isMobile,
  mobileSubmenuVisible,
  setMobileSubmenuVisible,
}) {
  const activeMenuClassName = (isActive) => {
    let className = '';
    if (!isSubMenu) {
      className += 'navigation__menu-item-link';
    }
    if (isActive) {
      className += isSubMenu ? ' selected' : ' navigation__menu-item--selected';
    }
    return className;
  };

  const parsedLink = useMemo(() => {
    const match = link.match(reg);

    if (!match) return link;

    const [, variable] = match;
    const newUrl = urls[variable] === window.location.origin ? '' : urls[variable];
    return link.replace(reg, urls ? newUrl : '');
  }, [link, urls]);

  const isOutsideLink = useMemo(
    () => parsedLink.indexOf('http') !== -1,
    [parsedLink],
  );

  const liClass = useMemo(() => classNames({
    'navigation__menu-item': !isMobile,
    'navigation__menu-item--active': isMenuItemActive(activeMenu) && !isMobile,

    'navigation__mobile__menu-item': isMobile,
    'navigation__mobile__menu-item--active': isMenuItemActive(activeMenu) && isMobile,
    'submenu-hidden': !mobileSubmenuVisible,
    isOut: isOutsideLink,
  }), [isMobile, isMenuItemActive, activeMenu, mobileSubmenuVisible]);

  return (
    <li className={liClass}>
      {isOutsideLink ? (
        <>
          <a href={parsedLink} className={isSubMenu ? '' : 'navigation__menu-item-link'}>
            {label}
            {isMobile && menu.length > 0 && (
              <i className={mobileSubmenuVisible ? 'icon--up' : 'icon--down'} />
            )}
          </a>
          {menu.length > 0 && (
            <ul>
              {menu.map((submenu) => (
                <NavigationLink
                  key={submenu.link}
                  {...submenu}
                  urls={urls}
                  isSubMenu
                  isMenuItemActive={isMenuItemActive}
                />
              ))}
            </ul>
          )}
        </>
      ) : (
        <>
          <NavLink
            to={parsedLink.replace(window.location.origin, '')}
            onClick={(e) => {
              if (menu.length > 0) {
                e.preventDefault();
                setMobileSubmenuVisible((old) => !old);
                return false;
              }
              return true;
            }}
            className={activeMenuClassName}
          >
            {label}
            {isMobile && menu.length > 0 && (
              <i className={mobileSubmenuVisible ? 'icon--up' : 'icon--down'} />
            )}
          </NavLink>
          {menu.length > 0 && (
            <ul>
              {menu.map((submenu) => (
                <NavigationLink
                  key={submenu.link}
                  {...submenu}
                  urls={urls}
                  isSubMenu
                  isMenuItemActive={isMenuItemActive}
                />
              ))}
            </ul>
          )}
        </>
      )}
    </li>
  );
}

NavigationLink.defaultProps = {
  menu: [],
  activeMenu: [],
  isSubMenu: false,
  isMobile: false,
  mobileSubmenuVisible: false,
  setMobileSubmenuVisible: () => {},
};

NavigationLink.propTypes = {
  isMenuItemActive: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  urls: PropTypes.object.isRequired,
  activeMenu: PropTypes.array,
  isMobile: PropTypes.bool,
  isSubMenu: PropTypes.bool,
  menu: PropTypes.array,
  mobileSubmenuVisible: PropTypes.bool,
  setMobileSubmenuVisible: PropTypes.func,
};
